const RATE_DECIMALS = 5;
const RATE_SCALE = 10 ** RATE_DECIMALS;

export const OTHER_VALUE = "other";

export function vatRateIsExplicitlySet(formVatRate: unknown): boolean {
  // 0 is a valid vat rate, not "unset" — only blank/null means "follow the plan default".
  return formVatRate !== "" && formVatRate != null;
}

// vat_rate is stored with RATE_DECIMALS decimal places, so rounding there keeps
// full storable precision (e.g. a plan's composite default 0.10556 -> "10.556%")
// while avoiding floating-point artifacts (e.g. 0.07 -> "7.000000000000001").
export function roundRate(rate: number): number {
  return Math.round(rate * RATE_SCALE) / RATE_SCALE;
}

export function rateToPercentage(rate: number): number {
  return Math.round(rate * RATE_SCALE) / (RATE_SCALE / 100);
}

export function percentageToRate(percentage: number): number {
  return roundRate(percentage / 100);
}

const STANDARD_RATES = [0, 0.25];

export function vatRatePresets(
  defaultVatRate: number | null | undefined
): number[] {
  const rates = new Set(STANDARD_RATES);
  if (defaultVatRate != null) {
    rates.add(roundRate(defaultVatRate));
  }

  return Array.from(rates).sort((a, b) => a - b);
}

export function isPresetVatRate(
  rate: number,
  defaultVatRate: number | null | undefined
): boolean {
  return vatRatePresets(defaultVatRate).includes(rate);
}

export function resolveVatRate(
  formVatRate: unknown,
  defaultVatRate: number | null | undefined
): number {
  const fallback = defaultVatRate ?? 0.25;
  if (!vatRateIsExplicitlySet(formVatRate)) {
    return fallback;
  }

  const parsed = Number(formVatRate);
  return Number.isNaN(parsed) ? fallback : parsed;
}
